<section class="contentAreaWrapper pt-10 xl:pt-[240px] xl:pb-[290px] relative bg-secondary overflow-hidden z-10">
    <div class="container">
        <div class="xl:flex xl:gap-[60px]">
            <div class="xl:max-w-[455px] xl:min-w-[455px]">
                <div class="intro-text !mb-3 xl:!mb-[45px]">
                    <h2 class="heading-primary-8xl" [innerHTML]="solutionData.heading | safeHtml"></h2>
                    <div class="editor-content *:!mb-3" [innerHTML]="solutionData.description | safeHtml"></div>
                </div>
                <p class="mb-[22px] xl:mb-0 font-inter-medium text-[#1E1E1E]">All of our solutions cater to diverse
                    financial
                    journeys, centered around you.</p>
            </div>
            <ul class="contentAreaWrapper__Items flex">
                <li>
                    <img [ngSrc]="assetsCDNUrl+'assets/images/our-solutions/salaried-professionals.svg'"
                        class="mb-[10px]" height="50" width="50" alt="Salaried Professionals" />
                    <p class="mb-0 text-black font-inter-medium">Salaried<br />Professionals</p>
                </li>
                <li>
                    <img [ngSrc]="assetsCDNUrl+'assets/images/our-solutions/founders-and-promoters.svg'"
                        class="mb-[10px]" height="50" width="50" alt="Founders & promoters" />
                    <p class="mb-0 text-black font-inter-medium">Founders &<br /> promoters</p>
                </li>
                <li>
                    <img [ngSrc]="assetsCDNUrl+'assets/images/our-solutions/business-owners.svg'" class="mb-[10px]"
                        height="50" width="50" alt="Business Owners" />
                    <p class="mb-0 text-black font-inter-medium">Business<br />Owners</p>
                </li>
                <li>
                    <img [ngSrc]="assetsCDNUrl+'assets/images/our-solutions/consultants-freelancers.svg'"
                        class="mb-[10px]" height="50" width="50" alt="Consultants/Freelancers" />
                    <p class="mb-0 text-black font-inter-medium">Consultants/<br />Freelancers</p>
                </li>
                <li>
                    <img [ngSrc]="assetsCDNUrl+'assets/images/our-solutions/global-indians.svg'" class="mb-[10px]"
                        height="50" width="50" alt="Global Indians" />
                    <p class="mb-0 text-black font-inter-medium">Global<br />Indians</p>
                </li>
                <li>
                    <img [ngSrc]="assetsCDNUrl+'assets/images/our-solutions/lawyers.svg'" class="mb-[10px]" height="50"
                        width="50" alt="Lawyers" />
                    <p class="mb-0 text-black font-inter-medium">Lawyers</p>
                </li>
                <li>
                    <img [ngSrc]="assetsCDNUrl+'assets/images/our-solutions/doctors.svg'" class="mb-[10px]" height="50"
                        width="50" alt="Doctors" />
                    <p class="mb-0 text-black font-inter-medium">Doctors</p>
                </li>
            </ul>
        </div>
    </div>
</section>